import { Query } from 'cogent-js';
import BaseApiService from './base';

export default class EntityChangelogApiService extends BaseApiService {
  constructor() {
    super();
    this.query = new Query();
  }

  fetch({ entityId, entityName, perPage = 10, page = 1 }) {
    const url = this.query
      .for('entity-changelogs')
      .where('entity_id', entityId)
      .where('entity_name', entityName)
      .params({ perPage, page })
      .get();
    return this.request({ method: 'get', url });
  }
}
